import { render, staticRenderFns } from "./lossSubsidyWeek.vue?vue&type=template&id=cdc129c0&scoped=true"
import script from "./lossSubsidyWeek.vue?vue&type=script&lang=js"
export * from "./lossSubsidyWeek.vue?vue&type=script&lang=js"
import style0 from "./lossSubsidyWeek.vue?vue&type=style&index=0&id=cdc129c0&prod&lang=css"
import style1 from "./lossSubsidyWeek.vue?vue&type=style&index=1&id=cdc129c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc129c0",
  null
  
)

export default component.exports